import { HStack } from '@chakra-ui/react'
import React from 'react'

import { StandardText } from '~shared-components/components'
import {
  RouterLink,
  RouterLinkProps,
} from '~shared-components/components/RouterLink/RouterLink'
import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconSearch } from '~shared-components/icons/brand/IconSearch'

export const ViewMoreLink = (props: RouterLinkProps) => {
  const t = useTranslations()
  return (
    <RouterLink {...props}>
      <HStack mt={8} px={4} spacing={3}>
        <IconSearch boxSize="20px" color="deepPurple" />
        <StandardText fontWeight="bold">{t('show_more.results')}</StandardText>
      </HStack>
    </RouterLink>
  )
}
